import Paper from "@mui/material/Paper";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {useSelector} from "react-redux";
import { detailsFinalSum, detailsFinalVat, jobsFinalSum, jobsFinalVat} from "./TableSums";
import { VATs } from "../../redux/settingsSlice";

export default function SumTable() {
    // Слушаем обновление jobs, но не используем.
    const jobs = useSelector(state => state.jobs.jobs); 

    const jobsVat = useSelector(state => state.settings.vats[VATs.jobs]);
    const partsVat = useSelector(state => state.settings.vats[VATs.parts]);

    const showVat = jobsVat.active || partsVat.active;

    const jobsSum = jobsFinalSum({ useVat: true });
    const detailsSum = detailsFinalSum({ useVat: true });

    return (
        <TableContainer component={Paper} sx={{ maxWidth: 600, mt: 3 }} elevation={4}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{'Работы'}</TableCell>
                        <TableCell>{'Запасные части'}</TableCell>
                        {showVat &&
                            <TableCell>{'НДС'}</TableCell>
                        }
                        <TableCell>{'Сумма'}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            {jobsSum.toFixed(2)}
                        </TableCell>
                        <TableCell>
                            {detailsSum.toFixed(2)}
                        </TableCell>
                        {showVat &&
                            <TableCell>
                                {(jobsFinalVat() + detailsFinalVat()).toFixed(2)}
                            </TableCell>
                        }
                        <TableCell>
                            {(jobsSum + detailsSum).toFixed(2)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}